import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PageWrapper from "../SignupPages/PageWrapper";
import ProgressBar from "../../components/ProgressBarWithBackArrow/ProgressBarWithBackArrow";
import "../SignupPages/SignupCommon.css";

const SermorelinPage9: React.FC = () => {
  const [selectedOption, setSelectedOption] = useState<string>("");
  const navigate = useNavigate();

  const options = ["Yes", "No"];

  useEffect(() => {
    const step8Completed = localStorage.getItem("completed-step-8");
      if (step8Completed) {
        navigate("/sermorelin/getting-started/step-9", { replace: true });
      } else {
        navigate("/sermorelin/getting-started/step-8", { replace: true });
      }
  }, []);

  useEffect(() => {
    const saved = localStorage.getItem(
      "Do_you_have_existing_uncontrolled_diabetes_with_a_hemoglobin_A1C_greater_than_9%"
    );
    if (saved) {
      const parsed = JSON.parse(saved);
      setSelectedOption(parsed.value);
    }
  }, []);

  const handleOptionClick = (option: string) => {
    setSelectedOption(option);

    localStorage.setItem(
      "Do_you_have_existing_uncontrolled_diabetes_with_a_hemoglobin_A1C_greater_than_9%",
      JSON.stringify({
        key: "Do_you_have_existing_uncontrolled_diabetes_with_a_hemoglobin_A1C_greater_than_9%",
        value: option,
      })
    );

    localStorage.setItem("completed-step-9", "true");
      if (option === "Yes") {
        setTimeout(() => {
        navigate("/sermorelin/disqualified");
      }, 1000);
      } else {
        setTimeout(() => {
        navigate("/sermorelin/getting-started/step-10");
      }, 1000);
      }
  };

  const handleBack = () => {
      navigate("/sermorelin/getting-started/step-8"); 
  };

  return (
    <PageWrapper>
      <div className="signup-page-container container">
        <ProgressBar progress={70} onBack={handleBack} />
        <div className="signup-content">
          <p className="signup-intro">
          Do you have existing uncontrolled diabetes with a hemoglobin A1C greater than 9%?
          </p>
          <div className="options options-box">
            {options.map((option) => (
              <label
                key={option}
                className={selectedOption === option ? "selected" : ""}
                onClick={() => handleOptionClick(option)}
              >
                {option}
              </label>
            ))}
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default SermorelinPage9;